import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import WaterTank from "../pages/services/water-tank/page";
import PipeCleaning from "../pages/services/pipe-cleaning/page";
import DrainCleaning from "../pages/services/drain-cleaning/page";
import Endoscope from "../pages/services/endoscope/page";
import Cases from "../pages/cases/page";
import Testimonials from "../pages/testimonials/page";
import TaoyuanPipe from "../pages/seo/taoyuan-pipe/page";
import WaterTankCleaning from "../pages/seo/water-tank-cleaning/page";
import RestaurantPipe from "../pages/seo/restaurant-pipe/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout><Home /></Layout>,
  },
  {
    path: '/about',
    element: <Layout><About /></Layout>,
  },
  {
    path: '/contact',
    element: <Layout><Contact /></Layout>,
  },
  {
    path: '/services/water-tank',
    element: <Layout><WaterTank /></Layout>,
  },
  {
    path: '/services/pipe-cleaning',
    element: <Layout><PipeCleaning /></Layout>,
  },
  {
    path: '/services/drain-cleaning',
    element: <Layout><DrainCleaning /></Layout>,
  },
  {
    path: '/services/endoscope',
    element: <Layout><Endoscope /></Layout>,
  },
  {
    path: '/cases',
    element: <Layout><Cases /></Layout>,
  },
  {
    path: '/testimonials',
    element: <Layout><Testimonials /></Layout>,
  },
  {
    path: '/seo/taoyuan-pipe',
    element: <Layout><TaoyuanPipe /></Layout>,
  },
  {
    path: '/seo/water-tank-cleaning',
    element: <Layout><WaterTankCleaning /></Layout>,
  },
  {
    path: '/seo/restaurant-pipe',
    element: <Layout><RestaurantPipe /></Layout>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
